// Transitions Svelte direcionais pra carta voando pra mesa.
//
// POR QUE EXISTE (bug "oponente jogou e a carta nao apareceu"):
// as classes CSS .card-fly-from-* usam @keyframes com 0% { opacity: 0 }
// e fill-mode both. Em mobile/aba background o browser (iOS Safari
// principalmente) suprime a animacao quando o elemento monta — ela
// nunca avanca do frame 0% e a carta fica PRESA INVISIVEL ate algo
// forcar repaint. Fix identico ao do 1v1 (Plays.svelte, 2026-05-27):
// transition Svelte roda no mount e o Svelte LIMPA o estilo ao
// terminar — o estado final e sempre o natural (visivel), mesmo que
// a animacao seja suprimida no meio.
//
// Bonus: se a aba ja esta oculta no mount (document.hidden), duracao 0
// — a carta simplesmente aparece, sem depender de animacao nenhuma.
import type { TransitionConfig } from 'svelte/transition';

function makeFly(axis: 'x' | 'y', dist: number) {
  return (_node: Element): TransitionConfig => ({
    duration: typeof document !== 'undefined' && document.hidden ? 0 : 520,
    easing: (t: number) => 1 - Math.pow(1 - t, 3),
    css: (t: number) => {
      const u = 1 - t;
      const move = dist * u;
      const ry = 540 * u;
      // overshoot: pico em scale 1.05 perto do fim, igual keyframe original
      const s = t < 0.85 ? 0.7 + (1.05 - 0.7) * (t / 0.85) : 1.05 - 0.05 * ((t - 0.85) / 0.15);
      const translate = axis === 'y' ? `translateY(${move}px)` : `translateX(${move}px)`;
      return `transform: ${translate} rotateY(${ry}deg) scale(${s}); opacity: ${Math.min(1, t * 1.5)};`;
    },
  });
}

export const flyFromTop = makeFly('y', -220);
export const flyFromBottom = makeFly('y', 220);
export const flyFromLeft = makeFly('x', -220);
export const flyFromRight = makeFly('x', 220);
